export default "__VITE_ASSET__3yZskV3d__"